module.exports = __webpack_public_path__ + "img/IMPORTANT NOTICE27 copy.1b99507f.jpg";